

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerWebToken } from './firebase'; // import your firebase function

// 1️ Register service worker first
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered:', registration);

      // 2️Call registerWebToken after SW is ready
      registerWebToken();
    })
    .catch((err) => {
      console.error('Service Worker registration failed:', err);
    });
} else {
  console.log('Service workers are not supported.');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
